import { defineMessages } from 'react-intl';

const visaDisputeReasons = defineMessages({
    MERCHANDISESERVICESNOTRECEIVED: {
        id: 'MerchandiseServicesNotReceived',
        defaultMessage: 'Merchandise/services not received',
    },
    CANCELLEDRECURRINGTRANSACTION: {
        id: 'CancelledRecurringTransaction',
        defaultMessage: 'Cancelled recurring transaction',
    },
    NOTASDESCRIBED: {
        id: 'NotAsDescribed',
        defaultMessage: 'Not as described',
    },
    DAMAGEDORDEFECTIVEMERCHANDISE: {
        id: 'DamagedOrDefectiveMerchandise',
        defaultMessage: 'Damaged or defective merchandise',
    },
    QUALITY: { id: 'Quality', defaultMessage: 'Quality' },
    COUNTERFEITMERCHANDISE: {
        id: 'CounterfeitMerchandise',
        defaultMessage: 'Counterfeit merchandise',
    },
    MISREPRESENTATION: {
        id: 'Misrepresentation',
        defaultMessage: 'Misrepresentation',
    },
    CREDITNOTPROCESSED: {
        id: 'CreditNotProcessed',
        defaultMessage: 'Credit not processed',
    },
    CANCELLEDMERCHANDISESERVICES: {
        id: 'CancelledMerchandiseServices',
        defaultMessage: 'Cancelled merchandise/services',
    },
    ORIGINALCREDITNOTACCEPTED: {
        id: 'OriginalCreditNotAccepted',
        defaultMessage: 'Original credit not accepted',
    },
    NONRECEIPTOFCASH: {
        id: 'NonreceiptOfCash',
        defaultMessage: 'Non-receipt of cash',
    },
    TERMSOFCONTRACTVIRTUALACCOUNT: {
        id: 'TermsOfContractVirtualAccount',
        defaultMessage: 'Terms of contract (virtual account)',
    },
    DUPLICATE: {
        id: 'Duplicate',
        defaultMessage: 'Duplicate',
    },
    INCORRECTACCOUNTNUMBER: {
        id: 'IncorrectAccountNumber',
        defaultMessage: 'Incorrect account number',
    },
    INCORRECTAMOUNT: {
        id: 'IncorrectAmount',
        defaultMessage: 'Incorrect amount',
    },
    INCORRECTCURRENCY: {
        id: 'IncorrectCurrency',
        defaultMessage: 'Incorrect currency',
    },
    INCORRECTTRANSACTIONCODE: {
        id: 'IncorrectTransactionCode',
        defaultMessage: 'Incorrect transaction code',
    },
    INVALIDDATA: {
        id: 'InvalidData',
        defaultMessage: 'Invalid data',
    },
    LATEPRESENTMENT: {
        id: 'LatePresentment',
        defaultMessage: 'Late presentment',
    },
    PAIDBYOTHERMEANS: {
        id: 'PaidByOtherMeans',
        defaultMessage: 'Paid by other means',
    },
});

export default visaDisputeReasons;
